import { CoefficientsPerWorkerClass } from 'constants/CoefficientsPerWorkerclass';
import { PlanningInThePastRole } from 'constants/PlanningInThePastRole';
import { PlanningInThePastState } from 'constants/PlanningInThePastState';
import {
  CONTRACT_COMPLIANCE__PLANNING_ROLE_API_USER,
  CONTRACT_COMPLIANCE__PLANNING_ROLE_MANAGER,
  CONTRACT_COMPLIANCE__PLANNING_ROLE_SUPER_ADMIN,
  CONTRACT_COMPLIANCE__PLANNING_STATE_FULL_SHORT,
  CONTRACT_COMPLIANCE__PLANNING_STATE_FULLY_ALLOWED,
  CONTRACT_COMPLIANCE__PLANNING_STATE_NONE_SHORT,
  CONTRACT_COMPLIANCE__PLANNING_STATE_NOT_ALLOWED,
  CONTRACT_COMPLIANCE__PLANNING_STATE_SAME_DAY_ONLY,
  CONTRACT_COMPLIANCE__PLANNING_STATE_SAME_DAY_SHORT,
} from 'translations/constants';

export const TEST_ID = 'planning-in-the-past';

/** Order of the table chips and of the side panel rows, as in the mockup. */
export const WORKER_CLASSES: CoefficientsPerWorkerClass[] = [
  CoefficientsPerWorkerClass.BED,
  CoefficientsPerWorkerClass.ARB,
  CoefficientsPerWorkerClass.EXT,
  CoefficientsPerWorkerClass.STUD,
  CoefficientsPerWorkerClass.FLEX,
];

export const ROLE_LABEL_KEYS: Record<PlanningInThePastRole, string> = {
  [PlanningInThePastRole.MANAGER]: CONTRACT_COMPLIANCE__PLANNING_ROLE_MANAGER,
  [PlanningInThePastRole.SUPER_ADMIN]: CONTRACT_COMPLIANCE__PLANNING_ROLE_SUPER_ADMIN,
  [PlanningInThePastRole.API_USER]: CONTRACT_COMPLIANCE__PLANNING_ROLE_API_USER,
};

/** Test-id slugs, so ids stay readable: planning-in-the-past-role-super-admin-… */
export const ROLE_SLUGS: Record<PlanningInThePastRole, string> = {
  [PlanningInThePastRole.MANAGER]: 'manager',
  [PlanningInThePastRole.SUPER_ADMIN]: 'super-admin',
  [PlanningInThePastRole.API_USER]: 'api-user',
};

/** Order of the three-state control: the most restrictive first. */
export const STATES: PlanningInThePastState[] = [
  PlanningInThePastState.NOT_ALLOWED,
  PlanningInThePastState.SAME_DAY_ONLY,
  PlanningInThePastState.FULLY_ALLOWED,
];

/** Short labels for the table chips ("BED: Full"). */
export const STATE_SHORT_LABEL_KEYS: Record<PlanningInThePastState, string> = {
  [PlanningInThePastState.NOT_ALLOWED]: CONTRACT_COMPLIANCE__PLANNING_STATE_NONE_SHORT,
  [PlanningInThePastState.SAME_DAY_ONLY]: CONTRACT_COMPLIANCE__PLANNING_STATE_SAME_DAY_SHORT,
  [PlanningInThePastState.FULLY_ALLOWED]: CONTRACT_COMPLIANCE__PLANNING_STATE_FULL_SHORT,
};

/** Full labels for the side panel's three-state control. */
export const STATE_LABEL_KEYS: Record<PlanningInThePastState, string> = {
  [PlanningInThePastState.NOT_ALLOWED]: CONTRACT_COMPLIANCE__PLANNING_STATE_NOT_ALLOWED,
  [PlanningInThePastState.SAME_DAY_ONLY]: CONTRACT_COMPLIANCE__PLANNING_STATE_SAME_DAY_ONLY,
  [PlanningInThePastState.FULLY_ALLOWED]: CONTRACT_COMPLIANCE__PLANNING_STATE_FULLY_ALLOWED,
};

export const STATE_SLUGS: Record<PlanningInThePastState, string> = {
  [PlanningInThePastState.NOT_ALLOWED]: 'none',
  [PlanningInThePastState.SAME_DAY_ONLY]: 'same-day',
  [PlanningInThePastState.FULLY_ALLOWED]: 'full',
};

/** Chip colours of the mockup: green when fully allowed, orange for same day only, grey when not allowed. */
export const STATE_CHIP_COLORS: Record<PlanningInThePastState, { color: string; backgroundColor: string }> = {
  [PlanningInThePastState.NOT_ALLOWED]: { color: '#9CA3AF', backgroundColor: '#F3F4F6' },
  [PlanningInThePastState.SAME_DAY_ONLY]: { color: '#C2410C', backgroundColor: '#FFF7ED' },
  [PlanningInThePastState.FULLY_ALLOWED]: { color: '#2E9E56', backgroundColor: '#EAF7EE' },
};
